import { render, staticRenderFns } from "./invoice-badge.vue?vue&type=template&id=04c9427e&"
import script from "./invoice-badge.ts?vue&type=script&lang=js&"
export * from "./invoice-badge.ts?vue&type=script&lang=js&"
import style0 from "./invoice-badge.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
